import React from 'react';
import {FormGroup, Divider, Input, Button, Icon, Select} from "spectre-react/dist/cjs";
import PropTypes from "prop-types";


class ClientWorkTimes extends React.PureComponent {
    static propTypes = {
        clients: PropTypes.array.isRequired,
    };

    constructor(props) {
        super(props);

        const clientWorkTimes = props.clientWorkTimes.slice();
        const clientWorkTimesArrayKeys = props.clientWorkTimes.map(() => Math.random().toString(16).slice(2));

        if (clientWorkTimes.length === 0) {
            clientWorkTimes.unshift({clientId: '', startTime: '', endTime: ''});
            clientWorkTimesArrayKeys.unshift(Math.random().toString(16).slice(2));
        }

        this.state = {
            clientWorkTimesArrayKeys,
            clientWorkTimes
        }
    }

    onChange = (ev) => {
        const [, indexStr, propName] = ev.target.name.match(/\w+\.(\d+)\.(\w+)/);
        const index = parseInt(indexStr, 10);

        const clientWorkTimes = this.state.clientWorkTimes.slice();
        clientWorkTimes[index] = {...clientWorkTimes[index], [propName]: ev.target.value};
        this.setState({clientWorkTimes});
    }

    renderRow(item, index, key) {
        const selectOptions = this.props.clients;

        return (
            <FormGroup key={key}>
                <div className="col-8 col-md-7 col-sm-6">
                    <Select small value={item.clientId} name={`clientWorkTimes.${index}.clientId`} onChange={this.onChange}>
                        <option value="">Выберите клиента:</option>
                        {selectOptions.map(([clientId, clientName]) => <option key={clientId} value={clientId}>{clientName}</option>)}
                    </Select>
                </div>
                <div className="col-4 col-md-5 col-sm-6 d-flex">
                    <div className="flex-1 d-flex">
                        {":"}
                        <Input small className="mx-1" type="text" placeholder="06:00"
                               value={item.startTime} onChange={this.onChange}
                               name={`clientWorkTimes.${index}.startTime`} id={`clientWorkTimes.${index}.startTime`}
                        />
                        {"–"}
                        <Input small className="mx-1" type="text" placeholder="15:00"
                               value={item.endTime} onChange={this.onChange}
                               name={`clientWorkTimes.${index}.endTime`} id={`clientWorkTimes.${index}.endTime`}
                        />
                    </div>
                    <Button action link small onClick={this.removeRow} data-index={index}>
                        <Icon icon="cross"/>
                    </Button>
                </div>
            </FormGroup>
        )
    }

    addRow = () => {
        this.setState(({clientWorkTimes, clientWorkTimesArrayKeys}) => ({
            clientWorkTimes: [...clientWorkTimes, {clientId: '', startTime: '', endTime: ''}],
            clientWorkTimesArrayKeys: [...clientWorkTimesArrayKeys, Math.random().toString(16).slice(2)]
        }));
    }

    removeRow = (ev) => {
        const index = parseInt(ev.currentTarget.dataset.index, 10);

        this.setState(({clientWorkTimes, clientWorkTimesArrayKeys}) => ({
            clientWorkTimes: clientWorkTimes.filter((_, i) => i !== index),
            clientWorkTimesArrayKeys: clientWorkTimesArrayKeys.filter((_, i) => i !== index)
        }));
    }

    render() {
        const {clientWorkTimes, clientWorkTimesArrayKeys} = this.state;

        return (
            <div className="form-horizontal px-1">
                {clientWorkTimes.map((item, index) => this.renderRow(item, index, clientWorkTimesArrayKeys[index]))}

                <Divider />

                <Button block link small onClick={this.addRow}>
                    <Icon icon="plus"/>
                </Button>
            </div>
        )
    }
}


export default ClientWorkTimes;